<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>圈子列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
    <el-row :gutter="20">
      <el-text>微信号：</el-text>
      <el-col :span="4">
        <el-input
          placeholder="请输入内容"       
          clearable
          v-model="txt1">
          </el-input>  
      </el-col>
      <el-row>
        <el-button @click="searchPage" :icon="search" circle>
          <el-icon><Search /></el-icon>
        </el-button>
      </el-row>
    </el-row>
    <!-- 新增、批量删除按钮 -->
    <el-row class="bt">
      <el-button type="primary" @click="addClick">+新增</el-button>
    </el-row>
    <!-- 管理列表 -->
    <el-table :data="tableData" style="width:100%">
		<el-table-column prop="wechatNum" label="微信号" />
		<el-table-column prop="nickname" label="发圈人" />
		<el-table-column prop="categoryName" label="类别" />
		<el-table-column prop="msg" label="圈子内容" />
		<el-table-column prop="createdTime" label="发信时间" />
    <el-table-column label="图片列表">
      <template #default="scope">
        <img :src="iItem" style="height: 40px; width:40px; margin:5px; float:left;" @click="showBig(iItem)" v-for="iItem in scope.row.imgList" />
      </template>
    </el-table-column>
    <el-table-column label="是否显示学校">
      <template #default="scope">
        {{ scope.row.isShowSchool == '1' ? "是":"否" }}
      </template>
    </el-table-column>
		<el-table-column prop="browerCount" label="浏览次数" />
		<el-table-column prop="zanCount" label="点赞次数" />
    <el-table-column label="是否显示">
      <template #default="scope">
        {{ scope.row.state == '1' ? "是":"否" }}
      </template>
    </el-table-column>

      <el-table-column fixed="right" label="操作" width="150">
        <template #default="scope">
          <el-button link type="primary" size="small" v-if="scope.row.state == '1'" @click="handleHidden(scope.row, 0)">隐藏</el-button>
          <el-button link type="primary" size="small" v-if="scope.row.state == '0'" @click="handleHidden(scope.row, 1)">显示</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="kh-page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="currentPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
  </el-card>
</div>
</template>

  
<script>

  export default{
    data(){
      return {
        tableData : [],
        txt1: '',
        currentPage: 1,
        currentPageSize: 10,
        totalCount: 0
      }
    },
    mounted:function(){
      this.getPage()
    },
    methods:{
      //添加
      addClick(){
        this.$router.push("/Admin/CirclesEdit")
      },
      getPage(){
        var ths = this
        var queryBO = {
          name: this.txt1,
          page: this.currentPage,
          pageSize: this.currentPageSize,
          sortField: ''
        }
        ths.$post('/Circles/queryPage',queryBO)
        .then(function (res) { 
            if(res.success){
              ths.tableData = res.data.rows
              ths.totalCount = res.data.records
              for(var i = 0; i < ths.tableData.length; i ++){
                var obj = ths.tableData[i];
                obj.imgList = [];
                if(obj.imgs){
                  obj.imgList = obj.imgs.split(",");
                }
              }
            }
        })
        .catch(function (err) {
          console.log(err)
        })    
      },
      handleEdit(row){
        this.$router.push("/Admin/CirclesEdit?id="+row.id)
      },
      handleHidden(row, state){
        if(confirm("确定要提交吗？")){
          var ths = this
          var data = {
            id: row.id,
            state: state
          };
          ths.$post('/Circles/update?', data)
            .then(function (res) { 
                alert(res.msg)
                if(res.success){
                  ths.getPage()
                }
            })
            .catch(function (err) {
              console.log(err)
            })      
        }
      },
      handleSizeChange(val) {
        this.currentPageSize = val
        this.getPage()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPage()
      },
      searchPage(){
        this.currentPage = 1
        this.getPage()
      }
    }
  }

</script>

<style>
.bt{
  padding:20px 0;
}
</style>